'use client';

import React, { useState } from "react";
import { FaArrowRight, FaSpinner } from "react-icons/fa6";
import { useTheme } from "../../context/ThemeContext";

const rectangle6Dark = "/assets/shapes/button-rect.svg";
const rectangle7Dark = "/assets/shapes/button-rect-2.svg";
const rectangle6Light = "/assets/shapes/button-rect-light.svg";
const rectangle7Light = "/assets/shapes/button-rect-2-light.svg";
export const StyledButton = ({
  className,
  text = "Explore",
  loading,
  ...props
}) => {
  const { theme, toggleTheme } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      className={`w-[260px] sm:w-[280px] md:w-[332px] flex items-center relative cursor-pointer z-10 ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <div className="inline-flex items-center flex-[0_0_auto] relative">
        <div
          className={`z-10 flex items-center gap-2 px-3 sm:px-4 py-[11px] pr-0 h-10 rounded-[4px_0px_0px_4px] bg-color-1 relative transition-all duration-200 ${
            isHovered || loading
              ? " w-[170px] sm:w-[180px] md:w-[241px] "
              : "w-[180px] sm:w-[190px] md:w-[250px]"
          }`}
        >
          <div className="w-fit mt-[-0.50px] tracking-[0] text-sm text-color-100 font-medium leading-[normal] relative text-nowrap">
            {text}
          </div>
        </div>

        <img
          loading="lazy"
          className="w-[38.1px] -ml-px h-10 scale-[1.03] relative "
          alt="Rectangle"
          // src={theme === "dark" ? rectangle6Light : rectangle6Dark}
          src={rectangle6Dark}
        />
      </div>

      <div className="flex items-center grow flex-1 -ml-1 relative">
        <img
          loading="lazy"
          className="w-[26.1px] h-10 scale-[1.03] relative"
          alt="Rectangle"
          src={rectangle7Dark}
        />

        <div className="grow flex-1 -ml-px h-10 overflow-hidden rounded-[0px_4px_4px_0px] bg-color-1 relative flex items-center justify-center">
          {loading ? (
            <FaSpinner className="animate-spin text-color-100 -ml-3" />
          ) : (
            <FaArrowRight
              className={`text-color-100 transition-all duration-200 -ml-3 ${
                isHovered ? "text-sm" : "text-xs"
              }`}
            />
          )}
        </div>
      </div>
    </button>
  );
};
